import { colors } from '../../../../styles/settings';
import { createStyle, createStyles } from '../../../../utils/createStyle';

export const FieldStyles = createStyles({
    inputWrapper: 'relative',
    showHide: 'text-brand-dark absolute right-2 top-1/2 cursor-pointer transform -translate-y-1/2',
    label: 'text-brand-dark mb-1 block',
    field: [
        'rounded-sm w-full text-brand-dark p-1 px-2',
        {
            background: 'transparent',
            outline: 'none',
            appearance: 'none',
            // boxShadow: `inset 0 0 0 transparent, 0 0 0 0 ${colors.brandDark}`,
            // transition: '100ms box-shadow ease-out, 100ms border-color ease-out',
            ':focus': {
                borderColor: colors.brandHighlight,
                // boxShadow: `inset 0 0 5px 0 #ADC5DB, 0 0 0 1px ${colors.brandHighlight}`,
            },
            '&.error': {
                borderColor: colors.error,
                // boxShadow: `inset 0 0 0 transparent, 0 0 0 1px ${colors.error}`,
            },
            '&.error:focus': {
                // boxShadow: `inset 0 0 5px 0 rgba(214, 0, 0, 0.4), 0 0 0 1px ${colors.error}`,
            },
            '&.toggle-space': {
                paddingRight: '60px',
            },
            // Removes MS Edge's password input clear and reveal buttons.
            '::-ms-reveal': { display: 'none' },
            '::-ms-clear': { display: 'none' },
        },
    ],
});

export const TextInput = createStyles({
    footer: createStyle('grid text-center text-xs text-grey-3 gap-2', {
        gridTemplateColumns: 'max-content max-content max-content',
    }),
});
